import { environment } from "src/environments/environment";

export const GlobalComponent = {
    API_URL: environment.API_URL,
    LMS_BASE_URL: environment.lmsBaseUrl
}